module.exports = __webpack_public_path__ + "static/media/home-zubehoer.dad92e29.jpg";